/**
 * apiConfig — single source of truth for the API base URL.
 *
 * Production (any non-localhost host): same-origin `/api/v1`. nginx proxies
 * `/api/` → backend on 127.0.0.1:8100, which keeps port 8100 internal and
 * eliminates Mixed Content errors on HTTPS pages.
 *
 * Local dev (localhost / 127.0.0.1): `http://localhost:8100/api/v1` so the
 * Vite dev server on :3000 can still talk to a backend on :8100 directly.
 *
 * SSR / no-window context (validation runners, Node tools): `/api/v1`.
 */
export function apiV1Base(): string {
  if (typeof window === 'undefined' || !window.location) return '/api/v1';
  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') {
    return 'http://localhost:8100/api/v1';
  }
  return '/api/v1';
}

export const API_V1_BASE: string = apiV1Base();
